import React from 'react';
import { CheckCircle } from 'lucide-react';
import { TextInput } from '../ui/TextInput';
import { PhoneInput } from '../ui/PhoneInput';
import { LocationSelector } from '../location/LocationSelector';
import { LABEL_TEXT } from '../ui/tokens';
import type { LocationSelection } from '../../types/location';

export interface ContactoValues {
  readonly telefono: string;
  readonly email: string;
  readonly email_confirm: string;
  readonly direccion: string;
}

interface MiembroFieldsContactoProps {
  readonly values: ContactoValues;
  readonly onFieldChange: (field: keyof ContactoValues, value: string) => void;
  readonly errors: Record<string, string>;
  readonly required?: boolean;
  readonly ubicacion: LocationSelection;
  readonly onUbicacionChange: (v: LocationSelection) => void;
}

export const MiembroFieldsContacto: React.FC<MiembroFieldsContactoProps> = ({
  values, onFieldChange, errors, required = false,
  ubicacion, onUbicacionChange,
}) => {
  const emailsCoinciden =
    values.email.trim() !== '' &&
    values.email === values.email_confirm &&
    !errors.email && !errors.email_confirm;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <div className="md:col-span-2">
          <PhoneInput label="Teléfono" value={values.telefono}
            onChange={(v) => onFieldChange('telefono', v)} error={errors.telefono} required={required} />
        </div>
        <div className="md:col-span-3">
          <TextInput label="Dirección" value={values.direccion}
            onChange={(v) => onFieldChange('direccion', v)} error={errors.direccion} required={required} />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput label="Email" type="email" value={values.email}
          onChange={(v) => onFieldChange('email', v)} error={errors.email} required={required} />
        <div>
          <TextInput label="Confirmar email" type="email" value={values.email_confirm}
            onChange={(v) => onFieldChange('email_confirm', v)} error={errors.email_confirm}
            required={required} />
          {emailsCoinciden && (
            <p className="mt-1 text-sm text-green-600 flex items-center gap-1">
              <CheckCircle className="w-3 h-3" />Los correos coinciden
            </p>
          )}
        </div>
      </div>
      <div>
        <span className={`block ${LABEL_TEXT} mb-1.5`}>
          Ubicación de residencia{required && <span className="text-red-500 ml-1">*</span>}
        </span>
        <LocationSelector
          value={ubicacion} onChange={onUbicacionChange}
          levels={['country', 'state', 'city']}

          labels={{ country: 'País', state: 'Estado/Región', city: 'Ciudad' }}
          placeholders={{ country: 'Selecciona país...', state: 'Selecciona estado/región...', city: 'Selecciona ciudad...' }}
          error={errors.ubicacion} />
      </div>
    </div>
  );
};
